"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Util_1 = require("./Util");
var ReportsRequestService = /** @class */ (function () {
    function ReportsRequestService() {
    }
    ReportsRequestService.parsePackInfo = function (data) {
        var packInfo = [];
        var resources = window.resources;
        var packs = data.Response && data.Response["Packs"];
        if (packs) {
            packInfo = packs.length
                ? packs.map(function (pack) {
                    var packInfo = {
                        serialNumber: pack["Pack"] && pack["Pack"]["SerialNumber"],
                        productCode: pack["Pack"] && pack["Pack"]["ProductCode"],
                        expiryDate: pack["Pack"] && Util_1.convertExpiryDate(pack["Pack"]["ExpiryDate"]),
                        batchId: pack["Pack"] && pack["Pack"]["BatchId"],
                        uprc: pack["Result"] && pack["Result"].Uprc,
                        status: (pack.Result.OperationCode).toString().startsWith("11") || (pack.Result.OperationCode).toString() === "NMVS_SUCCESS" ? resources.Success : resources.Error,
                        packState: pack["Result"] && pack["Result"].State,
                        warning: pack["Result"] && pack["Result"].Warning,
                        information: pack["Result"] && pack["Result"].Information,
                        isQueuedItem: !data.Response,
                        ragClass: pack.Result.PackActionResult.RagClass,
                        ragIcon: pack.Result.PackActionResult.RagIcon
                    };
                    return packInfo;
                })
                : [];
        }
        else {
            var packState_1 = data.Response && data.Response.State ? data.Response.State : resources.Unknown;
            var uprc_1 = data.Response && data.Response.AlertId;
            var status_1 = resources.Processing;
            if (data.Response) {
                if (!data.Response.OperationCode) {
                    status_1 = resources.Error;
                }
                else {
                    status_1 = data.Response.OperationCode.startsWith("11") || data.Response.OperationCode.toString() === "NMVS_SUCCESS" ? resources.Success : resources.Error;
                }
            }
            packInfo = data.Packs && data.Packs.length
                ? data.Packs.map(function (el) {
                    return {
                        batchId: el["BatchId"] ? el["BatchId"] : resources.Unknown,
                        expiryDate: el["ExpiryDate"] ? Util_1.convertExpiryDate(el["ExpiryDate"]) : resources.Unknown,
                        productCode: el["ProductCode"] ? el["ProductCode"] : resources.Unknown,
                        serialNumber: el["SerialNumber"] ? el["SerialNumber"] : resources.Unknown,
                        packState: packState_1,
                        status: status_1,
                        uprc: uprc_1,
                        warning: data.Response && data.Response.Warning,
                        information: data.Response && data.Response.Information,
                        isQueuedItem: !data.Response,
                        ragClass: data.Response && data.Response.ragClass,
                        ragIcon: data.Response && data.Response.ragIcon
                    };
                })
                : [];
        }
        return packInfo;
    };
    ReportsRequestService.parseServerData = function (data) {
        return data.map(function (el) {
            var resultObject = {};
            var userInfo, action;
            try {
                action = el.Request ? JSON.parse(el.Request.Body) : null;
            }
            catch (e) {
                console.error(e);
                action = null;
            }
            //console.log("action");
            //console.log(action);
            try {
                userInfo = JSON.parse(el.UserId);
            }
            catch (err) {
                console.error(err);
                userInfo = null;
            }
            //console.log("resolve request type");
            //console.log((action && action.State) || el.RequestType);
            resultObject.additionalInfo = {
                action: (action && action.State) || el.RequestType,
                submitTime: el.SubmissionTime ? new Date(el.SubmissionTime) : undefined,
                responseTime: el.Response ? new Date(el.Date) : undefined
            };
            resultObject.additionalInfoIsVisible = false;
            resultObject.id = el.Id;
            resultObject.userInfo = userInfo;
            resultObject.packs = ReportsRequestService.parsePackInfo(el);
            resultObject.isSinglePackResult = el.EntryCategory.startsWith("Single");
            return resultObject;
        });
    };
    return ReportsRequestService;
}());
exports.ReportsRequestService = ReportsRequestService;
//# sourceMappingURL=ReportsRequestService.js.map